module.exports = __webpack_public_path__ + "img/thumbnail_FormosanBlackBear_f_normal.39e221e7.png";